import { BikesRoute } from "@/modules/bikes/routes/bikes.route";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/bikes/")({
	component: BikesRoute,
});
